import { defineStore } from 'pinia'
import { commonService } from '@/services/commonService.ts'
import { prepareSort } from '@/assets/js/main.ts'

export const useCommonStore = defineStore('common', () => {
  async function getItems(
    basePath: string,
    page: number,
    perPage: number,
    sortParams?: { field: string; order: number | string } | null,
    searchField?: string | null,
    filterScopes?: Map<string, string>
  ) {
    return await commonService.index(
      basePath,
      page,
      perPage,
      prepareSort(sortParams),
      searchField,
      filterScopes
    )
  }

  return {
    getItems
  }
})
